import edu from "../edu"
// import courseList from "../items/course_list"
import studentList from "../items/student_list"
import classList from "../items/class_list"
import classStudentList from "../items/class_student_list"
// import classroomList from "../items/classroom_list"
import scheduleList from "../items/schedule_list"
import classRecordList from "../items/class_record_list"
import recordDetailList from "../items/class_record_detail_list"
import potentialList from "../items/potential_list"
import weekSchedule from "../items/week_schedule"
import importStudentResult from "../items/import_student_result"
import absenceList from "../items/absence_list"
import reviewList from "../items/review_list"

export default {
	path:'edu',
	name:'edu',
	component:edu,
	children:[
		{
			path: 'review/list',
			name: 'after-class-review-list',
			component: reviewList
		},
		// {
		// 	path:'course/list',
		// 	name:'course-list',
		// 	component:courseList
		// },
		{
			path:'student/list',
			name:'student-list',
			component:studentList
		},
		{
			path:'class/list',
			name:'class-list',
			component:classList
		},
		{
			path:'class/student/list',
			name:'class-student-list',
			component:classStudentList
		},
		// {
		// 	path:'classroom/list',
		// 	name:'classroom-list',
		// 	component:classroomList
		// },
		{
			path:'schedule/list',
			name:'schedule-list',
			component:scheduleList
		},
		{
			path:'class/record/list',
			name:'class-record-list',
			component:classRecordList
		},
		{
			path:'class/record/detail/list',
			name:'class-record-detail-list',
			component:recordDetailList
		},
		{
			path:'potential/list',
			name:'potential-list',
			component:potentialList
		},
		{
			path:'week/schedule',
			name:'week-schedule',
			component:weekSchedule
		},
		{
			path:'import/student/result/:batchNo',
			name:'import-student-result',
			component:importStudentResult
		},
		{
			path:'absence/list',
			name:'absence-list',
			component:absenceList
		},
	]
}
